import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../style/resident.css";

function ResidentManagement() {
  const navigate = useNavigate();
  const [residents, setResidents] = useState([
    { id: 1, name: "Sparsh", apartment: "A-101", phone: "9876543210" },
    { id: 2, name: "Tanmay", apartment: "B-203", phone: "9123456789" }
  ]);

  const [newResident, setNewResident] = useState({ name: "", apartment: "", phone: "" });
  const [editingResident, setEditingResident] = useState(null);

  // Handle form input change
  const handleChange = (e) => {
    setNewResident({ ...newResident, [e.target.name]: e.target.value });
  };

  // Add a new resident
  const handleAdd = () => {
    if (!newResident.name || !newResident.apartment || !newResident.phone) return;

    setResidents([...residents, { id: Date.now(), ...newResident }]);
    setNewResident({ name: "", apartment: "", phone: "" });
  };

  // Edit an existing resident
  const handleEdit = (resident) => {
    setEditingResident(resident);
    setNewResident(resident);
  };

  // Save edited resident
  const handleSaveEdit = () => {
    setResidents(residents.map(res => res.id === editingResident.id ? newResident : res));
    setNewResident({ name: "", apartment: "", phone: "" });
    setEditingResident(null);
  };

  // Delete a resident
  const handleDelete = (id) => {
    setResidents(residents.filter(res => res.id !== id));
  };

  return (
    <div className="admin-dashboard-wrapper">
    <nav className="resident-nav-bar">
        <div className="admin-nav-logo">Resident Management</div>
      </nav>

    <div className="resident-management-wrapper">
      
      {/* <h2 className="resident-title">Resident Management</h2> */}

      <div className="resident-form">
        <input type="text" name="name" placeholder="Resident Name" value={newResident.name} onChange={handleChange} />
        <input type="text" name="apartment" placeholder="Apartment No." value={newResident.apartment} onChange={handleChange} />
        <input type="text" name="phone" placeholder="Phone Number" value={newResident.phone} onChange={handleChange} />

        {editingResident ? (
          <button onClick={handleSaveEdit} className="resident-btn save-btn">Save Changes</button>
        ) : (
          <button onClick={handleAdd} className="resident-btn add-btn">Add Resident</button>
        )}
      </div>

      <div className="resident-list">
        <h3>Resident List</h3>
        {residents.length === 0 ? <p>No residents added yet.</p> : (
          <table>
            <thead>
              <tr>
                <th>Name</th>
                <th>Apartment</th>
                <th>Phone</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {residents.map((resident) => (
                <tr key={resident.id}>
                  <td>{resident.name}</td>
                  <td>{resident.apartment}</td>
                  <td>{resident.phone}</td>
                  <td>
                    <button onClick={() => handleEdit(resident)} className="edit-btn">Edit</button>
                    <button onClick={() => handleDelete(resident.id)} className="delete-btn">Delete</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
    <footer className="admin-dashboard-footer">
        <button className="admin-dashboard-nav-btn" onClick={() => navigate("/admin")}>
          Home
        </button>
        <button className="admin-dashboard-nav-btn" onClick={() => navigate("/property")}>
          Property Management
        </button>
        <button className="admin-dashboard-nav-btn" onClick={() => navigate("/adminreport")}>
          Reports
        </button>
      </footer>
    </div>
  );
}

export default ResidentManagement;
